import { Document, Page, StyleSheet } from "@react-pdf/renderer";
import AdvanceTableHeader from "../PDFComponents/AdvanceTableHeader";
import AmountDetails from "../PDFComponents/AmountDetails";
import AdvanceTableData from "../PDFComponents/AvanceTableData";
import CarTableData from "../PDFComponents/CarTableData";
import CarTableHeader from "../PDFComponents/CarTableHeader";
import Comments from "../PDFComponents/Comments";
import DetailHeader from "../PDFComponents/DetailHeader";
import EmployeeDetailList from "../PDFComponents/EmployeeDetailList";
import ExpenseTableData from "../PDFComponents/ExpenseTableData";
import ExpenseTableHeader from "../PDFComponents/ExpenseTableHeader";
import FlightTableData from "../PDFComponents/FlightTableData";
import FlightTableHeader from "../PDFComponents/FlightTableHeader";
import History from "../PDFComponents/History";
import HotelTableData from "../PDFComponents/HotelTableData";
import HotelTableHeader from "../PDFComponents/HotelTableHeader";
import PlainHeader from "../PDFComponents/PlainHeader";
import Policy from "../PDFComponents/Policy";
import ReportsMainHeader from "../PDFComponents/ReportsMainHeader";
import Signature from "../PDFComponents/Signature";
import TripDetailsList from "../PDFComponents/TripDetailsList";
import OtherTableHeader from "../PDFComponents/OtherTableHeader";
import OtherTableData from "../PDFComponents/OtherTableData";

const ReportsOne = ({
  data,
  tripsHistory,
  CommentsData,
  advanceData,
  expensesData,
  tripData,
}) => {
  const styles = StyleSheet.create({
    page: {
      paddingTop: 60,
      paddingLeft: 40,
      paddingRight: 40,
      lineHeight: 1.5,
      flexDirection: "column",
    },
  });
  console.log({ tripData });

  return (
    <>
      <Document>
        <Page size="A4" style={styles.page} wrap={false}>
          <ReportsMainHeader data={data} />
          <DetailHeader title="Employee Details" />
          <EmployeeDetailList data={data} />
          <DetailHeader title="Report Details" />
          <TripDetailsList data={data} />
          <DetailHeader title="Expense Summary" />
          <ExpenseTableHeader />
          <ExpenseTableData data={data} expensesData={expensesData} />
          <DetailHeader title="Advance Summary" />
          <AdvanceTableHeader />
          <AdvanceTableData data={advanceData} />
          <DetailHeader title="Travel Summary" />
          <PlainHeader title="Flight Reservations" />
          <FlightTableHeader />
          <FlightTableData data={tripData} />
          <PlainHeader title="Hotel Reservations" />
          <HotelTableHeader />
          <HotelTableData data={tripData} />
          <PlainHeader title="Car Rentals" />
          <CarTableHeader />
          <CarTableData data={tripData} />
          <PlainHeader title="Other" />
          <OtherTableHeader />
          <OtherTableData data={tripData} />
          {/* <DetailHeader title="Report Summary by Currency" />
          <ReportsTableHeader />
          <ReportsTableData data={data} /> */}
          <DetailHeader title="Policy Violation Details" />
          <Policy data={data} />
          <DetailHeader title="Comments" />
          <Comments data={CommentsData} />
          <DetailHeader title="History" />
          <History data={tripsHistory} />
          <DetailHeader title="Report Summary" />
          <AmountDetails data={data} />
          <Signature data={data} />
        </Page>
      </Document>
    </>
  );
};

export default ReportsOne;
